export default __webpack_public_path__ + "static/SR India - FSSC 22000 - Certificate-cc6765462bde07da2fadf536cf82428c.pdf";